import { render, staticRenderFns } from "./fansMgt.vue?vue&type=template&id=0083745c&scoped=true&"
import script from "./fansMgt.vue?vue&type=script&lang=js&"
export * from "./fansMgt.vue?vue&type=script&lang=js&"
import style0 from "./fansMgt.vue?vue&type=style&index=0&id=0083745c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083745c",
  null
  
)

component.options.__file = "fansMgt.vue"
export default component.exports